<lt-look-image
  class="lt-avatar__image should-stay-blocked"
  [lookImage]="lookImage()"
  [showErrorFallback]="false"
  [testId]="testId()"
  [altFallback]="altFallback()"
  fit="cover"
  focus="top"
  [fill]="true"
/>
